import React, { createRef, useRef, useState, useEffect } from "react";
import view from "./PopupLogin.view";
import "./PopupLogin.css";
import validator from "validator";
import { Password } from "@mui/icons-material";

export function PopupLogin(props) {
	const loginref = createRef();
	const signupref = createRef();
	const forgetpasswordref = createRef();
	const verifyotpref = createRef();
	const passwordresetref = createRef();

	const [state, setStateRaw] = useState({
		form: "login",
		errorMsg: "",
		failureMsg: "",
		loginFaild: "",
	});

	const setState = (partial) => {
		setStateRaw((prev) => ({ ...prev, ...partial }));
	};

	const instanceRef = useRef(null);
	if (!instanceRef.current) {
		instanceRef.current = {};
	}
	const self = instanceRef.current;

	const isValidPassword = (value) => {
		return validator.isStrongPassword(value, {
			minLength: 8,
			minLowercase: 1,
			minUppercase: 1,
			minNumbers: 1,
			minSymbols: 1,
		});
	};

	self.isValidPassword = isValidPassword;

	self.validate = (e, name, formref) => {
		let data = formref.getData();
		let errorMsg = "";
		switch (name) {
			case "email":
				if (!validator.isEmail(e.target.value)) {
					errorMsg = "Please enter the vaild email.";
				}
				break;
			case "password":
				if (!self.isValidPassword(e.target.value)) {
					errorMsg =
						"Password not strong. Use Minimum One special character,Minimum 8 letters,One uppercase letter,One lowercase letter,One number.";
				}
				break;
			case "confirm_password":
				if (data.password != e.target.value) {
					errorMsg = "Please match the password.";
				}
				break;
		}
		setState({ errorMsg });
	};

	self.getSession = () => {
		let localSessionID = localStorage.getItem("sessionID");
		return new Promise((resolve, reject) => {
			if (localSessionID) {
			 resolve(localSessionID);
			} else {
				api
					.getSessionID()
					.then((sessionID) => resolve(sessionID))
					.catch(reject);
			}
		});
	};

	self.onLogin = (e) => {
		let data = loginref.current.getData();
		let { loginFaild } = state;
		e.preventDefault();
		let load = loader("Logging in please wait...");
		api.login(data).then((res) => {
			if (res && res.statusCode === 200 && res.accessToken) {
				mixins.setAccessToken(res.accessToken);
				self.getSession().then((sessionId) => {
					localStorage.setItem("sessionID", sessionId);
					api.getuserProfile().then((res) => {
						self.setStore("user", res.data);
						setTimeout(() => {
							self.props.model.close();
							self.props.model.res(res.data);
							load.close();
						});
					}).catch(() => load.close());
				});
			} else {
				load.close();
				setState({
					loginFaild: "Invalid Credential"
				});
			}
		});
	};

	self.onSignup = (e) => {
		let data = signupref.current.getData();
		data['subscribe'] = data['subscribe'] == 'on';
		data.subscribe = `${data.subscribe}`;
		e.preventDefault();
		setState({ failureMsg: "" });
		if (state.errorMsg) {
			alert("Please fill the valid values.");
			return;
		}
		let load = loader("Signing up please wait...");
		api.signup(data).then((res) => {
			if (res && res.statusCode === 200 && res.accessToken) {
				mixins.setAccessToken(res.accessToken);
				self.getSession().then((sessionId) => {
					localStorage.setItem("sessionID", sessionId);
					api.getuserProfile().then((res) => {
						self.setStore("user", res.data);
						setTimeout(() => {
							self.props.model.close();
							self.props.model.res(res.data);
							load.close();
						});
					}).catch(() => load.close());
				});
			} else if (res && res.message) {
				let $USER_EXISTS = "The email has already been taken.";
				if (
					res.errorMessages.length >= 1 &&
					res.errorMessages.includes($USER_EXISTS)
				) {
					alert(
						"User is already registered, please login to continue"
					).promise.then(() => {
						setState({ form: "login" });
					});
				} else {
					setState({ failureMsg: res.message });
				}
				load.close();
			}
		});
	};

	self.onForgetPassword = (e) => {
		e.preventDefault();
		setState({ failureMsg: "" });
		if (state.errorMsg) {
			alert("Please fill the valid values.");
			return;
		}
		let data = forgetpasswordref.current.getData();
		let load = loader("Sending your verification code please wait...");
		api.forgot_password(data).then((res) => {
			if (res && res.statusCode === 200) {
				mixins.setAccessToken(res.accessToken);
				setState({ form: "otp-verify" });
			} else if (res && res.message) {
				setState({ failureMsg: res.message });
			}
			load.close();
		});
	};

	self.onVerifyOtp = (e) => {
		e.preventDefault();
		setState({ failureMsg: "" });
		if (state.errorMsg) {
			alert("Please fill the valid values.");
			return;
		}
		let data = verifyotpref.current.getData();
		let load = loader("Sending your verification code please wait...");
		api.otp_verification(data).then((res) => {
			if (res && res.statusCode === 200) {
				setState({ form: "new-password" });
			} else if (res && res.message) {
				setState({ failureMsg: res.message });
			}
			load.close();
		});
	};

	self.onPasswordReset = (e) => {
		e.preventDefault();
		setState({ failureMsg: "" });
		if (state.errorMsg) {
			alert("Please fill the valid values.");
			return;
		}

		let data = passwordresetref.current.getData();
		let load = loader("Password resetting please wait....");
		api.password_reset(data).then((res) => {
			if (res && res.statusCode === 200) {
				mixins.setAccessToken();
				setState({ form: "login" });
			} else if (res && res.message) {
				setState({ failureMsg: res.message });
			}
			load.close();
		});
	};

	Object.assign(self, {
		props,
		state,
		setState,
		loginref,
		signupref,
		forgetpasswordref,
		verifyotpref,
		passwordresetref,
	});

	self.props = props;
	initialConstruct.bind(self)("PopupLogin", props);

	useEffect(() => {}, []);

	return view.bind(self)(props, props.store, state);
}

export default connect(PopupLogin);
